import Swiper from 'swiper';

function clientsSwiper() {
  const clients = document.querySelector('.js-clients-swiper');
  if (clients) {
    const slidesLength = clients.querySelectorAll('.swiper-slide').length;

    window.addEventListener('load', () => {
      new Swiper (clients, {
        centerInsufficientSlides: true,
        breakpointsInverse: true,
        spaceBetween: 0,
        autoplay: true,
        speed: 1200,
        slidesPerView: 2,
        loop: slidesLength > 2,
        breakpoints: {
          576: {
            slidesPerView: 3,
            loop: slidesLength > 3,
          },
          992: {
            slidesPerView: 4,
            loop: slidesLength > 4,
          },
          1200: {
            slidesPerView: 5,
            loop: slidesLength > 5,
          },
        },
      });
    }, false);
  }
}

export default {
  init() {
    clientsSwiper();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/templateHome.js